import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import LanguageContext from '../../i18n/LanguageContext';

class ContactInfo extends Component {

    render() {

        const { t } = this.context;
        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="ltn__contact-address-area mb-90">
				<div className="container">
				<div className="row">
					<div className="col-lg-4">
					<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
						<div className="ltn__contact-address-icon">
						<img src={publicUrl+"assets/img/icons/10.png"} alt="Icon Image" />
						</div>
						<h3>{t('contact.emailTitle')}</h3>
						<p>roomytinyhouse@gmail.com<br /><br />

						</p>
					</div>
					</div>
					<div className="col-lg-4">
					<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
						<div className="ltn__contact-address-icon">
						<img src={publicUrl+"assets/img/icons/11.png"} alt="Icon Image" />
						</div>
						<h3>{t('contact.phoneTitle')}</h3>
						<p>0552 072 19 72 <br /> <br /> </p>
						<div className="btn-wrapper animated">
                  <a href="https://api.whatsapp.com/send?phone=905520721972" className="theme-btn-1 btn btn-effect-1">
                    {t('contact.reserve')}
                  </a>
                </div>
					</div>
					</div>
					<div className="col-lg-4">
					<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
						<div className="ltn__contact-address-icon">
						<img src={publicUrl+"assets/img/icons/12.png"} alt="Icon Image" />
						</div>
						<h3>{t('contact.locationTitle')}</h3>
						<p> Göl, Prof. Dr. Mehmet Abuç Cd.  <br />
						No:73, 54600 Sapanca/Sakarya</p>
						<div className="btn-wrapper animated">
                  <a href="https://www.google.com/maps/place/Roomy+Sapanca+Tiny+House/@40.6926074,30.2801103,15z/data=!4m2!3m1!1s0x0:0xe401c75072bcf937?sa=X&ved=2ahUKEwjxg5Dk_L6BAxWZXvEDHfFuCEYQ_BJ6BAhSEAA&ved=2ahUKEwjxg5Dk_L6BAxWZXvEDHfFuCEYQ_BJ6BAhiEAg" className="theme-btn-1 btn btn-effect-1">
                    {t('contact.locationBtn')}
                  </a>
                </div>
					</div>
					</div>
				</div>
				</div>
			</div>
        }
}

ContactInfo.contextType = LanguageContext;

export default ContactInfo
